import { PrimaryButton } from 'src/styles/globalStyles/buttonStyles.styled';
import {
  EmptyTableWrapper,
  EmptyContent,
  EmptyIconWrapper,
  EmptyContentWrapper,
  EmptyContentTitle,
  EmptyContentSubtitle,
} from './EmptyTableBody.styled';
import { EmptyTableBodyProps } from './EmptyTableBody.types';
import { Add20Regular } from '@fluentui/react-icons';

export const EmptyTableBody = ({
  title,
  subtitle,
  icon,
  emptyTableBodyButtonLabel,
  showAddTicketButton,
  toggleAddTicketPopup,
}: EmptyTableBodyProps) => {
  return (
    <EmptyTableWrapper>
      <EmptyContent>
        <EmptyIconWrapper>{icon}</EmptyIconWrapper>
        <EmptyContentWrapper>
          <EmptyContentTitle>{title}</EmptyContentTitle>
          <EmptyContentSubtitle>{subtitle}</EmptyContentSubtitle>
        </EmptyContentWrapper>

        {showAddTicketButton && (
          <PrimaryButton
            className="full-width"
            onClick={() => {
              toggleAddTicketPopup(true);
            }}
            size="medium"
            icon={<Add20Regular />}
            iconPosition="before"
          >
            {emptyTableBodyButtonLabel}
          </PrimaryButton>
        )}
      </EmptyContent>
    </EmptyTableWrapper>
  );
};
